import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Icon from '../AppIcon';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { signIn, authError, clearError } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    clearError();

    const result = await signIn(email, password);
    
    if (result?.success) {
      navigate('/');
    }
    
    setIsLoading(false);
  };

  const handleDemoLogin = async (role) => {
    setIsLoading(true);
    clearError();

    const demoCredentials = {
      admin: { email: 'admin@company.com', password: 'admin123' },
      user: { email: 'user@company.com', password: 'user123' }
    };

    const { email: demoEmail, password: demoPassword } = demoCredentials[role];
    const result = await signIn(demoEmail, demoPassword);
    
    if (result?.success) {
      navigate('/');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-primary rounded-lg flex items-center justify-center mb-4">
            <Icon name="BarChart3" size={24} className="text-primary-foreground" />
          </div>
          <h2 className="text-3xl font-bold text-foreground">
            Sales Analytics Portal
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Sign in to access your dashboard
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
                Email Address
              </label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-foreground mb-2">
                Password
              </label>
              <div className="relative">
                <Input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full pr-10"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon 
                    name={showPassword ? "EyeOff" : "Eye"} 
                    size={16} 
                    className="text-muted-foreground hover:text-foreground" 
                  />
                </button>
              </div>
            </div>
          </div>

          {authError && (
            <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-3">
              <div className="flex items-center space-x-2">
                <Icon name="AlertCircle" size={16} className="text-destructive" />
                <span className="text-sm text-destructive">{authError}</span>
              </div>
            </div>
          )}

          <div>
            <Button
              type="submit"
              className="w-full"
              disabled={isLoading}
              iconName={isLoading ? "Loader2" : "LogIn"}
              iconPosition="left"
            >
              {isLoading ? 'Signing in...' : 'Sign In'}
            </Button>
          </div>

          {/* <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-muted" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-background text-muted-foreground">
                  Demo Accounts
                </span>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => handleDemoLogin('admin')}
                disabled={isLoading}
                iconName="Shield"
                iconPosition="left"
                className="text-sm"
              >
                Admin Demo
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => handleDemoLogin('user')}
                disabled={isLoading}
                iconName="User"
                iconPosition="left"
                className="text-sm"
              >
                User Demo
              </Button>
            </div>
          </div> */}

          {/* <div className="text-center">
            <p className="text-xs text-muted-foreground">
              Use demo accounts to preview different access levels
            </p>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default Login;